import { render } from "./ProfitPercentage.vue?vue&type=template&id=5b4e7ed6"
import script from "./ProfitPercentage.vue?vue&type=script&lang=js"
export * from "./ProfitPercentage.vue?vue&type=script&lang=js"

import "./ProfitPercentage.vue?vue&type=style&index=0&id=5b4e7ed6&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__